export default __webpack_public_path__ + "static/media/34.a10c3c79.png";